import { DigitalWipService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type DigitalWipSendSmsQuotesProps = {
  soHeaderId: number;
};

export const useSendSmsQuotesMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof DigitalWipService.postDigitalWipSendSmsQuotes>>,
      QueryError,
      DigitalWipSendSmsQuotesProps,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ soHeaderId }: DigitalWipSendSmsQuotesProps) => {
      return DigitalWipService.postDigitalWipSendSmsQuotes(soHeaderId);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully Send!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
